<template lang="pug">
.qmodii-modal-content
  VCard
    VCardTitle
      span.headline {{ $t('screener.customCols') }}
      VSpacer
      VBtn(icon, @click="close()"): i.material-icons.md-18 close
    VCardText
      VLayout(align-space-around, justify-center, column)
        VFlex(xs12)
          VTextField(
            :label="$t('screener.entercol')",
            v-model="colToAdd",
            :error-messages="errormsg",
            @click:append-outer="addCol"
            @keydown.enter="addCol"
            :append-outer-icon="'add'"
            @input="inputChanged"
          )
        VFlex(xs12 v-if="gCustomTabItems.length")
          VDivider
          VSubheader {{ $t('screener.modify_existing') }}:
          VExpansionPanel(focusable v-model="openPanel")
            VExpansionPanelContent(v-for="(tab, tabIndex) in gCustomTabItems", :key="`tab-${tabIndex}`")
              template(slot="header")
                div {{ tab.label }}
              VCard
                VCardText.grey.lighten-5
                  VLayout(align-space-around, row, v-for="(tabItem, idx2) in columns") 
                    VFlex(xs3 v-for="(tableItem, idx2) in tabItem")
                      VCheckbox.qmod-rowcheckbox(
                        
                        :label="$t(`tableheaders.${tableItem.label}`)",
                        v-model="tab.items",
                        :value="tableItem"
                        @change="changeCols(tabIndex, tableItem)"
                        hide-details=true
                      )
                VCardActions
                  VBtn(color="red", flat, @click="removeTab(tabIndex)") remove view 
                  VSpacer
        VFlex(xs12 v-else)
          span {{ $t('screener.nosavedcol') }}.
    VCardActions
      VSpacer
      VBtn(color="green", flat, @click="close()") {{ $t('screener.save') }}
</template> 

<script>
import {
  VDialog,
  VDivider,
  VExpansionPanel,
  VExpansionPanelContent,
  VList,
  VSubheader,
  VCheckbox,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VListTileSubTitle,
  VListTileAction,
  VLayout,
  VFlex,
  VTextField,
  VSelect,
  VIcon,
  VBtn,
  VSpacer,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
} from "vuetify/lib";
import ToggleButton from "@LAYOUT/ToggleButton";
import axios from "axios";
import { mapGetters, mapState } from "vuex";

export default {
  name: "customModal",
  components: {
    VDialog,
    VDivider,
    VExpansionPanel,
    VExpansionPanelContent,
    VCheckbox,
    VList,
    VSubheader,
    VListTile,
    VListTileContent,
    VListTileTitle,
    VListTileSubTitle,
    VListTileAction,
    VLayout,
    VFlex,
    VTextField,
    VSelect,
    VIcon,
    ToggleButton,
    VBtn,
    VSpacer,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
  },
  props: ["enabled", "list",],
  data() {
    return {
      colToAdd: null,
      modal2: true,
      options: [],
      openPanel: null,
      existing: null,
      savingscreens: false,
      errormsg: [],
      cols: 4,
      selectedCols: []
    };
  },
  methods: {
    inputChanged() {
      if (this.errormsg.length) {
        this.errormsg.pop();
      }
    },
    removeTab(TAB_INDEX) {
      this.$store.commit("MarketScreener/REMOVE_ROW", TAB_INDEX);
    },
    changeCols(TAB_INDEX, CRITERA) {
      this.$store.commit("MarketScreener/SET_OR_UPDATE_COLS", {TAB_INDEX, CRITERA});
    },
    addCol() {
      let exists = 0;
      if (!this.colToAdd.trim()) {
        this.errormsg.push('Blank names are not allowed.');
        return;
      }
      this.gCustomTabItems.filter(view => {
        if (view.label == this.colToAdd) {
          this.errormsg.push('A view with that name already exists.');
          exists += 1;
          return;
        }
      })
      if (exists) {
        return;
      }
      const symbolKey = this.$store.state.MarketScreener.CURRENT_SCREENER === 'equity' ? 'companyBasics.symbol' : 'symbol';

      
      
      let TAB = {
        label: this.colToAdd,
        items: [{ label: 'symbol', class: '', key: symbolKey, format: 'formatSymbolFoward'}]
      };

      this.$store.commit("MarketScreener/SET_OR_UPDATE_TABS", TAB);

      this.openPanel = this.gCustomTabItems.length-1;
      this.$store.state.MarketScreener.CURRENT_TAB = this.colToAdd;

      this.colToAdd = '';
    },
    close() {
      this.$emit("finished");
    },
    closeModal() {
      this.$store.commit("AdvancedChart/SET_MODAL_ISOPEN", false);
    }
  },
  computed: {
    ...mapGetters("MarketScreener", [
      "gTabItems",
      "gCustomTabItems"
    ]),
    columns () {
      const datatype = this.$store.state.MarketScreener.CURRENT_SCREENER;

      function chunk (arr, len) {        
        var chunks = [], i = 0, n = arr.length;        
        while (i < n) {
          chunks.push(arr.slice(i, i += len));
        }
        
        return chunks;
      }

      function flatten (tabItems) {
        const keys = [];

        let combiedList = [];
        for (let index = 1; index < tabItems.length; index++) {
          const element = tabItems[index];
          combiedList = combiedList.concat(element.table.items);
        }
        combiedList = combiedList.filter(item => {
          const ignore = datatype === 'equity' ? 'companyBasics.symbol' : 'symbol';
          
          return item.key !== ignore;
        });
        
        combiedList = combiedList.filter((item2, itemIndex) => {
          return combiedList.indexOf(item2) === itemIndex
        });

        combiedList = combiedList.filter(item => {
          const alreadyInList = keys.indexOf(item.key) !== -1;

          if (alreadyInList) {
            return false;            
          } else {
            keys.push(item.key);
            return true;
          }
        })


        return combiedList;
      }

      let testCol = flatten(this.gTabItems);
      let columns = chunk(testCol, this.cols);

      return columns
    }
  },
  mounted() {
  },
  async created() {
    // await this.getScreens();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.qmodii-modal-content
  width 100%
  .qmod-rowcheckbox
    text-transform: capitalize
    padding-top: 0;
    margin-top 0
    .v-label
      font-size 14px
.qmod-color-box-cont
  display flex
  justify-content space-between
  margin-top 5px
  .qmod-color-box
    max-width 30px
    height 30px
    flex auto
    cursor pointer
    text-align center
    color #fff
    &.qmod-color-box-active
      border 1px solid black
      &:after
        position relative
        top 3px
        content '✔'
.qmodii-select.qmodii-input-color, .qmodii-input.qmodii-input-color
  width 100%
  max-width 100%
  height 30px
.qmodii-active-list-item
  &.qmodii-modal-btn-bar
    margin-top 10px
.qmodii-list-item, .qmodii-active-list-item
  border-bottom 1px solid #e4e4e4
  margin 2px 0
  display flex
  align-items center
  .qmodii-c-mag
    margin-left 2px
    .qmodii-btn
      border-radius 50%
      padding 8px
      transition background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
      &.qmodii-active, &:hover
        border 2px solid black
  .qmodii-marg-left
    margin-left auto
  .qmodii-marg-right
    flex 1
    margin-right auto
  .qmodii-marg-auto
    margin auto
</style>
